<div *ngIf="sanitizeUrl?.changingThisBreaksApplicationSecurity">
  <!-- Zoom Controls -->
  <div class="zoom-controls">
    <ion-button fill="clear" size="small" (click)="zoomOut()">
      <ion-icon name="remove-circle-outline"></ion-icon>
    </ion-button>
    <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
    <ion-button fill="clear" size="small" (click)="zoomIn()">
      <ion-icon name="add-circle-outline"></ion-icon>
    </ion-button>
    <ion-button fill="clear" size="small" (click)="resetZoom()">
      <ion-icon name="contract-outline"></ion-icon>
    </ion-button>
  </div>

  <pdf-viewer class = "pdf-viewer" [ngClass] = "{'blurDocument' : showLoading}" 
  [src]="sanitizeUrl?.changingThisBreaksApplicationSecurity" 
  [show-all] = "true"
  [autoresize]="true" 
  [original-size]="false" 
  [fit-to-page]="false"
  [zoom]="zoom"
  [show-borders]="false"
  [render-text]="true"
  [external-link-target]="'blank'"
  (after-load-complete)="afterLoadComplete()"
  (text-layer-rendered)="textLayerRendered()" 
  (error)="onError()" 
  (on-progress)="onProgress()"></pdf-viewer>
</div>